/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_ErrorInputs */

const id_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const ms_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat`)
};

const da_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl`)
};

const de_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const en_us2_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const es_es2_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const es_mx2_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fil_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const it_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const hu_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba`)
};

const nl_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout`)
};

const no_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil`)
};

const pl_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd`)
};

const pt_br2_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const pt_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

const ro_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare`)
};

const fi_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe`)
};

const sv_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel`)
};

const vi_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi`)
};

const tr_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata`)
};

const cs_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba`)
};

const bg_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка`)
};

const ru_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const uk_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка`)
};

const ar_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ`)
};

const hi_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि`)
};

const th_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาด`)
};

const ja_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const zh_cn2_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_hant1_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const ko_components_comparison_error = /** @type {(inputs: Components_Comparison_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Components_Comparison_ErrorInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_error = /** @type {((inputs?: Components_Comparison_ErrorInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_ErrorInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_error(inputs)
	if (locale === "ms") return ms_components_comparison_error(inputs)
	if (locale === "da") return da_components_comparison_error(inputs)
	if (locale === "de") return de_components_comparison_error(inputs)
	if (locale === "en-US") return en_us2_components_comparison_error(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_error(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_error(inputs)
	if (locale === "fil") return fil_components_comparison_error(inputs)
	if (locale === "fr") return fr_components_comparison_error(inputs)
	if (locale === "it") return it_components_comparison_error(inputs)
	if (locale === "hu") return hu_components_comparison_error(inputs)
	if (locale === "nl") return nl_components_comparison_error(inputs)
	if (locale === "no") return no_components_comparison_error(inputs)
	if (locale === "pl") return pl_components_comparison_error(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_error(inputs)
	if (locale === "pt") return pt_components_comparison_error(inputs)
	if (locale === "ro") return ro_components_comparison_error(inputs)
	if (locale === "fi") return fi_components_comparison_error(inputs)
	if (locale === "sv") return sv_components_comparison_error(inputs)
	if (locale === "vi") return vi_components_comparison_error(inputs)
	if (locale === "tr") return tr_components_comparison_error(inputs)
	if (locale === "cs") return cs_components_comparison_error(inputs)
	if (locale === "bg") return bg_components_comparison_error(inputs)
	if (locale === "ru") return ru_components_comparison_error(inputs)
	if (locale === "uk") return uk_components_comparison_error(inputs)
	if (locale === "ar") return ar_components_comparison_error(inputs)
	if (locale === "hi") return hi_components_comparison_error(inputs)
	if (locale === "th") return th_components_comparison_error(inputs)
	if (locale === "ja") return ja_components_comparison_error(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_error(inputs)
	return ko_components_comparison_error(inputs)
});
export { components_comparison_error as "components.comparison.error" }